import { deleteGoviewProject, GoviewProject } from '@/api/goview';
import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from '@ant-design/icons';
import { Card, Dropdown, MenuProps, message, Modal, Tag } from 'antd';
import React, { useState } from 'react';
import './ProjectCard.less';

export interface ProjectCardProps {
  record: GoviewProject;
  onEdit?: (record: GoviewProject) => void;
  onDelete?: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ record, onEdit, onDelete }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handlePreview = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (record.previewAddress) {
      window.open(record.previewAddress, '_blank');
    }
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (record.editAddress) {
      window.open(record.editAddress, '_blank');
    }
  };

  const handleDelete = () => {
    Modal.confirm({
      title: '确认删除',
      content: `确定要删除项目"${record.projectName}"吗？此操作不可恢复。`,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        try {
          const resp = await deleteGoviewProject(record.id);
          if (resp.success) {
            message.success('删除成功');
            onDelete?.();
          } else {
            message.error(resp.errorMsg || '删除失败');
          }
        } catch (error) {
          message.error('删除失败，请稍后重试');
        }
      },
    });
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'delete',
      label: (
        <div onClick={handleDelete} style={{ color: '#ff4d4f' }}>
          <DeleteOutlined style={{ marginRight: 8 }} />
          删除
        </div>
      ),
    },
  ];

  return (
    <Card 
      className="project-card" 
      hoverable
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="project-card__content">
        <div className="project-card__image-wrapper">
          <img
            src={record.indexImage || require('@/assets/images/default.32752796.png')}
            alt={record.projectName}
            className="project-card__image"
            onError={(e) => {
              (e.target as HTMLImageElement).src = require('@/assets/images/default.32752796.png');
            }}
          />
          <div className="project-card__status">
            <Tag 
              color={record.state === 1 ? 'success' : undefined} 
              className={`project-card__status-tag ${record.state === 1 ? 'project-card__status-tag--published' : 'project-card__status-tag--unpublished'}`}
            >
              {record.state === 1 ? '已发布' : '未发布'}
            </Tag>
          </div>
          {isHovered && (
            <div className="project-card__actions">
              <button 
                className="project-card__action-btn"
                onClick={handlePreview}
                title="查看"
              >
                <EyeOutlined />
              </button>
              <button 
                className="project-card__action-btn"
                onClick={handleEdit}
                title="编辑"
              >
                <EditOutlined />
              </button>
            </div>
          )}
        </div>
        <div className="project-card__title-wrapper">
          <div className="project-card__title">
            {record.projectName}
          </div>
          <div className="project-card__bottom-actions">
            <Dropdown
              menu={{ items: menuItems }}
              trigger={['hover']}
              placement="bottomRight"
            >
              <button 
                className="project-card__bottom-btn"
                onClick={(e) => e.stopPropagation()}
                title="更多"
              >
                <MoreOutlined />
              </button>
            </Dropdown>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ProjectCard;

